// extracted by mini-css-extract-plugin
export default {"container":"editAgent_container__xLfqA"};